:host {
  --icon-size: var(--jb-icon-size, 1.5rem);
  --icon-color: var(--jb-icon-color, currentColor);
  --icon-color-complementary: var(--jb-icon-color-complementary, var(--jb-primary));
  --icon-stroke-width-thin: 48;
  --icon-stroke-width: 64;
  --icon-stroke-width-thick: 96;
  height: var(--icon-size);
}

/*size variants*/
:host([size="xs"]) {
  --icon-size: var(--jb-icon-size-xs, 1rem);
}

:host([size="sm"]) {
  --icon-size: var(--jb-icon-size-sm, 1.25rem);
}

:host([size="md"]) {
  --icon-size: var(--jb-icon-size-md, 1.5rem);
}

:host([size="lg"]) {
  --icon-size: var(--jb-icon-size-lg, 1.75rem);
}

:host([size="xl"]) {
  --icon-size: var(--jb-icon-size-xl, 2.25rem);
}


/*color variants*/
:host([color="primary"]) {
  --icon-color: var(--jb-icon-color-primary, var(--jb-primary, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-primary, var(--jb-icon-color-complementary, var(--jb-secondary)));
}

:host([color="secondary"]) {
  --icon-color: var(--jb-icon-color-secondary, var(--jb-secondary, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-secondary, var(--jb-icon-color-complementary, var(--jb-primary)));

}

:host([color="positive"]) {
  --icon-color: var(--jb-icon-color-positive, var(--jb-green, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-positive, var(--jb-icon-color-complementary, var(--jb-green-subtle)));
}

:host([color="danger"]) {
  --icon-color: var(--jb-icon-color-danger, var(--jb-red, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-danger, var(--jb-icon-color-complementary, var(--jb-red-subtle)));
}

:host([color="warning"]) {
  --icon-color: var(--jb-icon-color-warning, var(--jb-yellow, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-warning, var(--jb-icon-color-complementary, var(--jb-yellow-subtle)));
}

:host([color="light"]) {
  --icon-color: var(--jb-icon-color-light, var(--jb-neutral-10, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-light, var(--jb-icon-color-complementary, var(--jb-neutral)));
}

:host([color="dark"]) {
  --icon-color: var(--jb-icon-color-dark, var(--jb-neutral, currentColor));
  --icon-color-complementary: var(--jb-icon-color-complementary-dark, var(--jb-icon-color-complementary, var(--jb-content-inverse)));
}
